module.exports = __webpack_public_path__ + "static/media/ionic-ios-checkbox-outline.88b07c48.svg";